export const teamData = [
  {
    id: 1,
    name: 'Paul Nkingwa Thomas',
    role: 'CEO & Lead Developer',
    avatar: '👑',
    initials: 'PT',
    color: 'from-primary-500 to-yellow-500',
    bio: 'Visionary founder and lead developer behind Riven Byte Studios. Passionate about crafting world-class African gaming experiences and building the future of game development in Tanzania.',
    social: {
      twitter: '#',
      linkedin: '#',
      github: '#',
    },
  },
  {
    id: 2,
    name: 'Godlove Hipolite',
    role: 'Cybersecurity Expert & Product Testing',
    avatar: '🛡️',
    initials: 'GH',
    color: 'from-cyan-500 to-indigo-600',
    bio: "Cybersecurity specialist who keeps Riven Byte's products and players safe. Brings deep expertise in threat analysis and secure architecture to the dev process, and leads hands-on product testing to ensure every release ships tight, polished, and secure.",
    social: {
      linkedin: '#',
      github: '#',
    },
  },
  {
    id: 3,
    name: 'Andrew Katabalo',
    role: 'Creative Director & Art Director',
    avatar: '🎨',
    initials: 'AK',
    color: 'from-secondary-400 to-purple-500',
    bio: 'The creative force shaping the visual identity and artistic direction of every Riven Byte title. Brings African art traditions and contemporary design into stunning gaming worlds.',
    social: {
      twitter: '#',
      linkedin: '#',
      instagram: '#',
    },
  },
];

export const leadershipTeam = teamData.slice(0, 2);
export const fullTeam = teamData;

export default teamData;
